import { Component } from '@angular/core';
import { RoleFacade } from 'app/shared/services/facades/role.facade';
import { tr, DialogService, Navigator, DialogResult } from '@kpd/framework-ngx';
import { RoleKey } from 'app/shared/models/keys/role-key';
import { RolesNavigatorHelper } from 'app/roles/roles-navigator-helper';
import { switchMap, catchError } from 'rxjs/operators';
import { Role } from 'app/shared/models/role';
import { RoleService } from 'app/shared/services/role.service';
import { of } from 'rxjs';
import { Permissions } from 'app/shared/services/permissions';

@Component({
  selector: 'app-roles-sidepanel',
  templateUrl: './roles-sidepanel.component.html',
})
export class RolesSidepanelComponent {
  Permissions: typeof Permissions = Permissions;
  navigatorHelper: RolesNavigatorHelper;
  userCount = 0;

  constructor(
    public roleFacade: RoleFacade,
    private dialogService: DialogService,
    private navigator: Navigator,
    private roleService: RoleService,
  ) {
    this.navigatorHelper = new RolesNavigatorHelper(navigator);
  }

  onItemChange(item: Role): void {
    if (!!item && !!item.key && item.key.isDefined()) {
      this.roleService.getRoleUsers(item.key as RoleKey).subscribe((users) => {
        this.userCount = users.length;
      });
    }
  }

  onAdd(): void {
    this.roleFacade.clearSelection();
    this.navigatorHelper.navigateToCreateFromDetail(true);
  }

  onView(roleKey: RoleKey): void {
    this.navigatorHelper.navigateToConsult(roleKey);
  }

  onEdit(roleKey: RoleKey): void {
    this.navigatorHelper.navigateToEdit(roleKey);
  }

  navigateToPermissionSets(key: RoleKey): void {
    this.navigator.navigateChild(['roles', 'details', 'application', key.application, 'role', key.name], {
      queryParams: { tab: 'permissionSets' },
    });
  }

  navigateToUsers(key: RoleKey): void {
    this.navigator.navigateChild(['roles', 'details', 'application', key.application, 'role', key.name], {
      queryParams: { tab: 'users' },
    });
  }

  onDelete(selectedIds: RoleKey[]): void {
    const message = tr('Are you sure to delete one (or more) selected roles?');
    this.dialogService
      .open('confirm', {
        message,
        header: tr('Delete role(s)'),
        verifyButtonText: tr('Delete'),
        verifyButtonStyle: 'danger',
        cancelButtonText: tr('Cancel'),
      })
      .afterClosed()
      .pipe(
        switchMap((result) => {
          if (result === DialogResult.Verify) {
            return this.roleFacade.deleteItems(selectedIds);
          }
          return of({});
        }),
        catchError((error: any) => {
          if (error.status === 409 || error.status === 400) {
            return this.dialogService
              .open('conflict', {
                message: tr(`Cannot delete role due to conflict(s)`),
                header: tr('Delete failed'),
                severity: 'danger',
              })
              .afterClosed();
          }
          throw error;
        }),
      )
      .subscribe(() => {});
  }
}
